const landingPageTranslations = {
  welcomeCard: {
    title: "You Ready !",
    description:
      "The greatest glory in living lies not in never falling, but in rising every time we fall.",
    actionButtons: {
      contactUs: "Contact Us",
      watchTutorial: "Watch Tutorial",
    },
  },
  quickNavigations: {
    title: "Let's Get Started",
    nutritionPlan: "Nutrition Plan",
    workoutPlan: "Workout Plan",
    startDate: "Start Date",
    endDate: {
      title: "End Date",
      callToAction: "Freeze Subscriptions",
    },
  },
};

export default landingPageTranslations;
